import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const initState = () => ({
  keyword: '积分',
  hasInit: false,
  hasLoaded: false,
  hasSubmit: false,
  signUpEvent: false,
  redAmount:'',
  isInvalidAddress: false,
  moduleConfig: {},
  rightBtn: {
    form: {}
  },
  formMap: {},
  leftBtn: {
    form: {}
  },
  signUpDialogVisible: false,
  posterImage: '',
  currentActivity: {
    browsing: 0,
    points: 0,
    redbag: 0,
    availablePoints: 0,
  },
  myAward: {
    share: 0,
    points: 0,
    redbag: 0,
    availablePoints: 0,
    usedPoints: 0
  },
  redBagAward: [],
  pointsAward: [],
  awardInfo: []
})

const store = new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  plugins: process.env.NODE_ENV === 'development' ? [createLogger()] : [],
  state: initState(),
  mutations: {
    initConfig(state, config) {
      Object.assign(state, {
        ...config,
        hasInit: true
      })
    },
    initData(state) {
      Object.assign(state, {
        hasLoaded: true
      })
    },
    resetState(state) {
      Object.assign(state, initState())
    },
    setInvalidAddress(state) {
      state.isInvalidAddress = true
    },
    setFormMap(state, formMap) {
      state.formMap = Object.assign({}, state.formMap, formMap)
    },
    setForm(state, {type, items}) {
      state[type].form = Object.assign({}, state[type].form, {
        items
      })
    },
    changeEventProps(state, { key, value }) {
      state[key] = value
    },
    setPosterImage(state, image) {
      state.posterImage = image
    },
    setMyAward(state, payload) {
      Object.assign(state.myAward, payload)
    },
    setCurrentActivity(state, payload) {
      Object.assign(state.currentActivity, payload)
    },
    setAwardInfo(state, { redBagAward, pointsAward, awardInfo }) {
      state.redBagAward = redBagAward
      state.pointsAward = pointsAward
      state.awardInfo = awardInfo
    },
    setHasSumbit(state, value) {
      state.hasSubmit = value
    },
    setSignUpEvent(state, value) {
      state.signUpEvent = value
    },
    setRedAmount(state, value) {
      state.redAmount = value
    }
  },
  actions: {
    initConfig({ commit }, payload) {
      commit('initConfig', payload)
    },
    initData({ commit }) {
      commit('initData')
    },
    resetState({ commit }) {
      commit('resetState')
    },
    setFormMap({ commit }, payload) {
      commit('setFormMap', payload)
    },
    setForm({ commit }, payload) {
      commit('setForm', payload)
    },
    changeEventProps({ commit }, payload) {
      commit('changeEventProps', payload)
    },
    setPosterImage({ commit }, payload) {
      commit('setPosterImage', payload)
    },
    setMyAward({ commit }, payload) {
      commit('setMyAward', payload)
    },
    setCurrentActivity({ commit }, payload) {
      commit('setCurrentActivity', payload)
    },
    setAwardInfo({ commit }, payload) {
      commit('setAwardInfo', payload)
    },
    setHasSumbit({ commit }, payload) {
      commit('setHasSumbit', payload)
    },
    setSignUpEvent({ commit }, payload) {
      commit('setSignUpEvent', payload)
    },
    setRedAmount({ commit }, payload) {
      commit('setRedAmount', payload)
    },
    setInvalidAddress({ commit }) {
      commit('setInvalidAddress')
    }
  }
})

export default store